export default {
  'Agravo de Instrumento - Recurso de Revista': 1,
  'Agravo de Instrumento - Recurso Ordinário': 2,
  'Embargos no TST': 3,
  'Recurso de Ação Rescisória': 4,
  'Recurso Extraordinário': 5,
  'Recurso Ordinário': 6,
  'Recurso de Revista': 7
}
